module.exports = __webpack_public_path__ + "img/world.e1f4b774.png";